(() => {
  const initialise = (root = document) => {
    const fields = root.querySelectorAll('[data-cmj-contact-fields]:not([data-cmj-contact-ready])');
    const params = new URLSearchParams(window.location.search);
    const allowedTopics = new Set(['product', 'sizing', 'order', 'bespoke', 'wedding_band', 'aftercare']);
    for (const group of fields) {
      group.dataset.cmjContactReady = 'true';
      if (group.hasAttribute('data-cmj-contact-errors')) continue;
      const topic = group.querySelector('[data-cmj-enquiry-topic]');
      const requestedTopic = (params.get('enquiry') || '').replaceAll('-', '_');
      if (topic && allowedTopics.has(requestedTopic)) topic.value = requestedTopic;
      const design = group.querySelector('[data-cmj-enquiry-design]');
      const requestedDesign = params.get('product') || params.get('design') || params.get('band');
      if (design && requestedDesign && !design.value) design.value = requestedDesign.slice(0, 240);
      const requestedBand = params.get('band');
      const details = [params.get('colour') || params.get('color') || params.get('metal'), params.get('size'), requestedBand !== requestedDesign ? requestedBand : null].filter(Boolean).map(value => value.slice(0, 100));
      const context = group.querySelector('[data-cmj-enquiry-context]');
      const contextWrap = group.querySelector('[data-cmj-enquiry-context-wrap]');
      if (details.length && context && contextWrap) {
        context.value = details.join(' · ').slice(0, 300);
        contextWrap.hidden = false;
      }
    }
  };
  const revealHash = () => {
    let id;
    try {
      id = decodeURIComponent(window.location.hash.slice(1));
    } catch {
      return;
    }
    if (!id.startsWith('cmj-')) return;
    const target = document.getElementById(id);
    if (target instanceof HTMLDetailsElement) target.open = true;
  };
  const start = () => {
    initialise();
    revealHash();
  };
  if (!window.cmjClientServicesReady) {
    window.cmjClientServicesReady = true;
    document.addEventListener('shopify:section:load', event => initialise(event.target));
    window.addEventListener('hashchange', revealHash);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  } else {
    start();
  }
})();
